<template>
  <v-container>
    <v-layout row wrap>
      <v-dialog v-model="dialog" max-width="500">
      <!-- <v-btn color="info" slot="activator">Add User</v-btn> -->
      <v-btn
        v-show="currentUserAdmin"
        color="green"
        slot="activator"
        dark
        absolute
        top
        small
        right
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{dialogText.title}}
        </v-card-title>
        <v-container>
          <v-layout column>
            <v-flex xs12 v-if="currentUserAdmin">
              <v-text-field
                v-model="user.kontaktId"
                label="Kontakt ID"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              Kontakt ID: {{user.kontaktId}}
            </v-flex>
            <v-flex xs12 v-if="currentUserAdmin">
              <v-text-field
                v-model="user.beaconAddress"
                label="Beacon Address"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              Beacon Address: {{user.beaconAddress}}
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="user.firstName"
                label="First Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="user.lastName"
                label="Last Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-container>
                  <span>Toggle this switch on to hide card from the main screen. This is useful if no one is using this card</span>
                  <v-switch
                    v-model="user.hideOnMainScreen"
                    :label="`${user.hideOnMainScreen ? 'Hidden from' : 'Visible on'} main screen`"
                  ></v-switch>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="saveUser"
          >
            {{dialogText.button}}
          </v-btn>
          <v-btn
            color="red"
            flat
            @click="dialog = false; user = ''"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h3>Users</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headersComputed"
            :items="dataTable"
            :search="search"
            :loading="!dataReady"
          >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.kontaktId }}</td>
              <td class="text-xs-right">{{ props.item.name }}</td>
              <td class="text-xs-right" v-show="currentUserAdmin">{{ props.item.beaconAddress }}</td>
              <td class="text-xs-right">
                <v-btn icon flat class="orange" @click="openEditDialog(props.item.id)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn v-if="currentUserAdmin" icon flat class="red" @click="deleteUser(props.item)">
                  <v-icon>remove</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="deleteUserModal">
      <v-card>
        <v-container>
          <v-card-title>
            <h2>Are you sure you want to delete?</h2>
          </v-card-title>
          <v-card-text>
            <span><h3>{{user.name}}</h3></span>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            @click="deleteUserFromFirebase"
          >
            Yes, Delete
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="deleteUserModal = false; user = ''"
          >
            No, Cancel
          </v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from '@/main.js'
import firebase from 'firebase'
// const users = db.collection('users')
export default {
  data () {
    return {
      dataReady: false,
      search: '',
      users: [],
      userStatus: [],
      headers: [
          {
            text: 'Card ID', align: 'left', value: 'kontaktId'
          },
          { text: 'Name', align: 'right', value: 'name' },
          {
            text: 'Beacon Add.',
            align: 'right',
            sortable: true,
            value: 'beaconAddress'
          },
          { text: 'Action', align: 'right' }
      ],
      dialog: false,
      dialogText: {
        title: 'Add User',
        button: 'Save'
      },
      user: {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        kontaktId: '',
        id: '',
        hideOnMainScreen: false
      },
      hideOnMainScreen: false,
      deleteUserModal: false,
      // Admin only
      currentUserAdmin: false
    }
  },
  created() {
    if(firebase.auth().currentUser){
      this.name = firebase.auth().currentUser.email
      let uid = firebase.auth().currentUser.uid
      let query = db.collection('adminUsers').where('uid', '==', uid).get().then(snapshot => {
        if(snapshot.docs.length === 1){
          this.currentUserAdmin = true
        }
      })
    }
  },
  computed: {
    dataTable () {
      let data = []
      if (this.users !== null) {
        this.users.forEach(u => {
          let obj = {
            name: `${u.firstName} ${u.lastName}`,
            beaconAddress: u.beaconAddress,
            kontaktId: u.kontaktId,
            id: u.id,
            hideOnMainScreen: u.hideOnMainScreen == null ? false : u.hideOnMainScreen
          }
          data.push(obj)
            
        })
      }
      return data
    },
    headersComputed () {
      let headers = [
          {
            text: 'Card ID', align: 'left', value: 'kontaktId'
          },
          { text: 'Name', align: 'right', value: 'name' },
          { text: 'Action', align: 'right' }
      ]
      // v-show="currentUserAdmin"
      if(this.currentUserAdmin){
        headers = [
          {
            text: 'Card ID', align: 'left', value: 'kontaktId'
          },
          { text: 'Name', align: 'right', value: 'name' },
          {
            text: 'Beacon Add.',
            align: 'right',
            sortable: true,
            value: 'beaconAddress'
          },
          { text: 'Action', align: 'right' }
      ]
      }
      return headers
    }
  },
  methods: {
    openEditDialog(userId) {
      this.dialogText.title = 'Edit User'
      this.dialogText.button = 'Update'
      this.user = this.users.find(u => u.id === userId)
      this.dialog = true
    },
    saveUser() {
      console.log(this.user)
      let obj = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          beaconAddress: this.user.beaconAddress,
          kontaktId: this.user.kontaktId,
          hideOnMainScreen: 'hideOnMainScreen' in this.user ? this.user.hideOnMainScreen : false
        }
        console.log(obj)
      if (this.user.id === '') {
        db.collection('users').add(obj)
      } else {
        db.collection('users').doc(this.user.id).update(obj)
      }
      this.dialog = false
      this.user = {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        id: '',
        hideOnMainScreen: false
      }
    },
    deleteUser(user) {
      console.log(user)
      this.user = user
      this.deleteUserModal = true
    },
    deleteUserFromFirebase() {
      db.collection('users').doc(this.user.id).delete()
      this.deleteUserModal = false
      this.user = {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        id: '',
        hideOnMainScreen: false
      }
    }
  },
  mounted () {
    this.$bind('users', db.collection('users'))
      .then((doc) => {
        this.dataReady = true
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/User.vue